import React, { useRef, useState } from "react";
import { format } from "date-fns";
import { buildName, Singleton } from "helper/tools";
import RevisarResetPasswordModal from "./RevisarResetPasswordModal";

export default function ConfiguracionesTable({
  items,
  tryApprove,
  openItem,
  reload,
}) {
  const creditLevelActionsModalRef = useRef();

  const [item, setItem] = useState({});

  const tryApprove1 = async (newItem) => {
    /*let response = await pagoniApproveResetPassword(item.username).catch(
      (e) => {}
    );
    if (!response) return;
    fetchData();*/

    setItem(newItem);
    creditLevelActionsModalRef.current.toggleModal();

    console.log("-->");
  };

  const editRow = (event, item) => {
    console.log(event + "  -  " + item);
    return false;
  };

  return (
    <>
      <RevisarResetPasswordModal
        ref={creditLevelActionsModalRef}
        item={item}
        reload={reload}
      />
      <table className="table table-borderless datable">
        <thead className="table-light" style={{ textAlign: "center" }}>
          <tr>
            <th style={{ width: "180px" }} scope="col">
              Fecha
            </th>
            <th scope="col">Username</th>
            <th scope="col">Nombre</th>
            <th scope="col">Acciones</th>
          </tr>
        </thead>
        <tbody style={{ textAlign: "center" }}>
          {items &&
            items.data?.length > 0 &&
            items.data?.map((item) => {
              const nombre = buildName(item, true);

              const date = format(
                item.resetPasswordSolicitado,
                "dd/MM/yy hh:mm a",
              );

              return (
                <tr key={item.id}>
                  <td>{date}</td>
                  <th scope="row">
                    {/* <a href="#" onClick={(e) => openItem(item)}> */}
                    {item.username ?? ""}
                    {/*</a>*/}
                  </th>
                  <td>{nombre}</td>
                  <td>
                    <button
                      type="button"
                      className={`btn btn-sm btn-warning`}
                      onClick={(e) => tryApprove1(item)}
                    >
                      Revisar
                    </button>
                  </td>
                </tr>
              );
            })}
        </tbody>
      </table>
    </>
  );
}
